import getShipViaOptions from 'cart-ui-react/src/service/getShipViaOptions';
import checkForExistingUser from 'cart-ui-react/src/service/checkForExistingUser';
import getOrderAutoShipCodeFromOrder from 'cart-ui-react/src/service/getOrderAutoShipCodeFromOrder';
import {
  orderContainsConditionWithTag,
  getConditionMessageByTagName,
} from 'cart-ui/src/service/orderConditionHelpers';
import getAppState from 'app-state';

angular.module('checkout').controller('checkoutAddress', [
  '$window',
  '$location',
  '$scope',
  'orderMgr',
  'rcmEventManager',
  'rcmApiLibMessageService',
  'allowedStates',
  'shippingVerification',
  'geoCode4Factory',
  '$sce',
  function (
    $window,
    $location,
    $scope,
    orderMgr,
    rcmEventManager,
    rcmApiLibMessageService,
    allowedStates,
    shippingVerification,
    geoCode4Factory,
    $sce
  ) {
    const self = this;

    const messageNamespace = 'checkoutAddress';

    self.hideContent = orderMgr.executeCurrentPageRequirements();

    // self.order = null;
    self.myPage = '/checkout/address';
    self.hasMessage = false;
    self.userAlreadyExists = false;
    self.duplicateData = null;
    self.fieldMessages = {};
    self.shipViaOptionsLoading = true;
    self.shipViaOptions = [];
    self.display = {};

    self.onSubmitModal = false;

    self.billAddressMeta = {
      hasStates: false,
      states: [],
      originalBillAddress: null,
    };

    self.shipAddressMeta = {
      hasStates: false,
      states: [],
    };

    self.verifiedShipAddressSelected = true;

    self.verifiedAddress = {};

    self.iso2 = '';

    self.shipMethodDescription = '';

    /* <GEO CODE BIT> */
    self.geoCodeState = {
      geoCodes: [],
      selectedGeoCode: null,
      haveGeoCodeOptions: false,
    };

    const handleGeoCodeStateChanged = function (geoCodeState) {
      self.geoCodeState = geoCodeState;
      if (
        self.geoCodeState.selectedGeoCode &&
        self.geoCodeState.selectedGeoCode.geoCode
      ) {
        self.order.shipping.data.shipAddress.geoCode =
          self.geoCodeState.selectedGeoCode.geoCode;
        self.order.shipping.data.shipAddress.state =
          self.geoCodeState.selectedGeoCode.state;
        self.order.shipping.data.shipAddress.city =
          self.geoCodeState.selectedGeoCode.city;
      }
      refreshShipViaOptions(); // Is needed to support zips that only contain one geo code option
    };

    const geoCode = geoCode4Factory.createInstance(handleGeoCodeStateChanged);

    /**
     * geoCodeInit
     */
    const geoCodeInit = function () {
      if (self.order.attributes.countryRules.collectGeo && isMyPage()) {
        geoCode.handleChange(self.order.shipping.data.shipAddress.postalCode, {
          city: self.order.shipping.data.shipAddress.city,
          state: self.order.shipping.data.shipAddress.state,
          geoCode: self.order.shipping.data.shipAddress.geoCode,
        });
      }
    };

    /**
     * geoCodeUpdate
     */
    const geoCodeUpdate = function () {
      if (self.order.attributes.countryRules.collectGeo && isMyPage()) {
        self.order.shipping.data.shipAddress.geoCode = null;
        self.order.shipping.data.shipAddress.city = null;
        self.order.shipping.data.shipAddress.state = null;
        geoCode.handleChange(
          self.order.shipping.data.shipAddress.postalCode,
          self.geoCodeState.selectedGeoCode
        );
      }
    };

    self.showShipViaOptions = function () {
      const guestOrderingEnabled = getAppState(
        'pws.guestOrderingEnabled',
        false
      );
      return (
        self.order &&
        self.order.attributes &&
        (self.order.attributes.currentUserRules.loggedIn ||
          guestOrderingEnabled) &&
        !self.order.attributes.enrollmentRules.orderIsEnrollment &&
        !!self.order.shipping.data.shipAddress.city &&
        !!self.order.shipping.data.shipAddress.country
      );
    };

    function refreshShipViaOptions() {
      if (!self.showShipViaOptions()) {
        return;
      }
      const shipAddress = self.order.shipping.data.shipAddress;
      self.shipViaOptionsLoading = true;

      getShipViaOptions(
        self.order.items.map((orderItem) => {
          return { itemCode: orderItem.skuNumber, quantity: orderItem.qty };
        }),
        shipAddress.country,
        shipAddress.postalCode,
        shipAddress.city,
        shipAddress.state,
        self.order.attributes.currentUserRules.profile.status,
        getOrderAutoShipCodeFromOrder(self.order),
        self.order.user.userId
      ).then(function (viaOptions) {
        const optionExists = !!viaOptions.find(
          (option) =>
            option.value.toString() ===
            self.order.shipping.data.shipVia.toString()
        );
        if (
          viaOptions.length === 1 ||
          (!optionExists && viaOptions.length > 0)
        ) {
          // If there is only one via option, automatically select it,
          // Also if the option we had selected before doesn't exist, select the first option
          self.order.shipping.data.shipVia = viaOptions[0].value;
        }
        self.shipViaOptions = viaOptions;
        self.shipViaOptionsLoading = false;
        $scope.$apply();
      });
    }

    /**
     * onSelectShipGeoCode
     */
    self.onSelectShipGeoCode = function () {
      handleGeoCodeStateChanged(self.geoCodeState);
      refreshShipViaOptions();
    };

    /**
     * onShipPostalCodeChange
     */
    self.onShipPostalCodeChange = function () {
      geoCodeUpdate();
      refreshShipViaOptions();
    };

    self.onAutoShipChange = function () {
      refreshShipViaOptions();
    };

    self.onShipCityChange = function () {
      refreshShipViaOptions();
    };

    /**
     * onShipPostalCodeChange
     */
    self.onShipCountryChange = function () {
      self.getStates(
        self.order.shipping.data.shipAddress.country,
        self.shipAddressMeta
      );
      refreshShipViaOptions();
    };

    /**
     * updateStates
     *
     * @param model
     * @param states
     */
    self.updateStates = function (model, states) {
      model.hasStates = states && states.length > 0;
      model.states = states;
    };

    /**
     * hasStates
     *
     * @param country
     * @returns {boolean}
     */
    self.hasStates = function (country) {
      return (
        self.order.attributes.countryRules.countriesWithNoState.indexOf(
          country
        ) < 0 &&
        typeof country === 'string' &&
        country !== ''
      );
    };

    /**
     * getStates
     *
     * @param country
     * @param model
     */
    self.getStates = function (country, model) {
      if (!self.hasStates(country)) {
        self.updateStates(model, []);
        return;
      }

      allowedStates.getStates(country, function (states) {
        self.updateStates(model, states);
      });
    };

    /**
     * submitAddressOption from modal window
     */
    self.submitAddressOption = function () {
      if (self.verifiedShipAddressSelected) {
        self.order.shipping.data.shipAddress = self.verifiedAddress;
      }
      self.onSubmitModal = false;
      self.updateAddresses();
    };

    /**
     * effectiveAddressDataPrep
     *
     * @param address
     */
    self.displayAddressVerificationWindow = function (address) {
      self.verifiedAddress = address;
      self.onSubmitModal = true;
      // set default input radio button to verified address
      self.verifiedShipAddressSelected = true;

      // This is required due to the promise pattern
      $scope.$apply();
    };

    /**
     * verifyAddress
     */
    self.verifyAddress = function () {
      self.onSubmitModal = false;

      const body = {
        phone: self.order.shipping.data.shipAddress.phone,
        email: self.order.shipping.data.shipAddress.email,
      };
      geoCode.setState({ loading: true });

      if (self.order.user.userId) {
        shippingVerification
          .getVerifiedShippingAddress(self.order.shipping.data.shipAddress)
          .then((address) => {
            self.displayAddressVerificationWindow(address);
            geoCode.setState({ loading: false });
          })
          .catch(self.updateAddresses);
      } else {
        checkForExistingUser(body)
          .then(function (response) {
            const message = response?.data?.message;
            self.userAlreadyExists = message.phoneExists || message.emailExists;
            if (message.emailExists && message.phoneExists) {
              self.duplicateData = 'Email and/or phone number';
            } else if (message.phoneExists) {
              self.duplicateData = 'phone number';
            } else if (message.emailExists) {
              self.duplicateData = 'Email address';
            }
            if (!self.userAlreadyExists) {
              shippingVerification
                .getVerifiedShippingAddress(
                  self.order.shipping.data.shipAddress
                )
                .then(self.displayAddressVerificationWindow)
                .catch(self.updateAddresses);
            }
            geoCode.setState({ loading: false });
          })
          .catch(geoCode.setState({ loading: false }));
      }
    };

    /**
     * checkUser
     */
    self.checkUser = function (trigger) {
      if (
        self.order.user.userId ||
        (!self.order.shipping.data.shipAddress.phone && trigger === 'phone') ||
        (!self.order.shipping.data.shipAddress.email && trigger === 'email')
      )
        return false;
      const body = {
        phone: self.order.shipping.data.shipAddress.phone,
        email: self.order.shipping.data.shipAddress.email,
      };
      geoCode.setState({ loading: true });
      checkForExistingUser(body)
        .then(function (response) {
          const message = response?.data?.message;
          self.userAlreadyExists = message.phoneExists || message.emailExists;
          if (message.emailExists && message.phoneExists) {
            self.duplicateData = 'Email and/or phone number';
          } else if (message.phoneExists) {
            self.duplicateData = 'phone number';
          } else if (message.emailExists) {
            self.duplicateData = 'Email address';
          }
          geoCode.setState({ loading: false });
        })
        .catch(geoCode.setState({ loading: false }));
    };

    /**
     * redirectToLogin
     */
    self.redirectToLogin = function () {
      window.location.href =
        '/login?redirect=%2Fsecure%2Fcheckout%2Fv2%23%2Fpayment&checking-out=true';
    };

    /**
     * Service Call to update addresses
     */
    self.updateAddresses = function () {
      syncAddresses();
      self.order.billAddress.verified = true;
      self.order.shipping.data.shipAddress.verified = true;
      self.order.shipping.data.shipAddress.type = 'BasicShipAddress';

      // Format Api Data
      const order = {
        billAddress: self.order.billAddress,
        shipping: {
          type: 'ShippingVistaDefault',
          data: {
            shipAddress: self.order.shipping.data.shipAddress,
            shipVia: self.order.shipping.data.shipVia,
            isAutoShip: self.order.shipping.data.isAutoShip,
            autoShipIsMonthly: self.order.shipping.data.autoShipIsMonthly,
          },
        },
        attributes: {
          isPvq: self.order.attributes.isPvq,
        },
      };

      orderMgr.patchOrder(order);
      geoCode.setState({ loading: false });
    };

    const syncAddresses = function () {
      if (self.order.attributes.billAddressSameAsShipAddress) {
        self.order.billAddress = angular.copy(
          self.order.shipping.data.shipAddress
        );
      }
    };

    const renderShipMethodDescription = () => {
      const description = self.shipViaOptions.find(
        (possibleOption) =>
          possibleOption.value == self.order.shipping.data.shipVia
      );
      self.shipMethodDescription =
        $sce.trustAsHtml(description?.description) || '';
    };

    /**
     * isMyPage
     *
     * @returns {boolean}
     */
    const isMyPage = function () {
      return $location.path() == self.myPage;
    };

    /**
     * redirectToLogin
     */
    const redirectToLogin = function () {
      if (isMyPage()) {
        self.order = null;
        // Redirect to login page if we are not allowed to show prices
        $window.location.href =
          '/login?redirect=' + encodeURIComponent('/cart#/my-cart');
      }
    };

    /**
     * setFieldMessages
     *
     * @param messages
     */
    const setFieldMessages = function (messages) {
      self.fieldMessages = messages;
      $scope.$apply();
    };

    /**
     * setMessage
     *
     * @param message
     */
    const setMessage = function (message) {
      self.hasMessage = true;
      rcmApiLibMessageService.setMessage(message, messageNamespace);
    };

    /**
     * handleMessages
     *
     * @param messages
     */
    const handleMessages = function (messages) {
      rcmApiLibMessageService.getTypeMessages(
        messages,
        'validatorMessage',
        setFieldMessages
      );
      rcmApiLibMessageService.getPrimaryMessage(messages, handleMessage);
    };

    /**
     * handleMessage
     *
     * @param message
     */
    const handleMessage = function (message) {
      // only allow on message at a time
      rcmApiLibMessageService.clearMessages(messageNamespace);
      if (message.type == 'httpStatus') {
        redirectToLogin();
        return;
      }
      setMessage(message);
    };

    /**
     * onOrderChange
     *
     * @param order
     */
    const onOrderChange = function (order) {
      self.order = order;
      if (!isMyPage()) {
        return;
      }
      self.getStates(
        self.order.shipping.data.shipAddress.country,
        self.shipAddressMeta
      );
      self.getStates(self.order.billAddress.country, self.billAddressMeta);

      self.billAddressMeta.sameAsShipAddress =
        self.order.attributes.billAddressSameAsShipAddress;

      geoCodeInit();
      refreshShipViaOptions();
    };

    /**
     * onPatchOrderSubmit
     */
    const onPatchOrderSubmit = function () {
      self.hasMessage = false;
      rcmApiLibMessageService.clearMessages(messageNamespace);
    };

    /**
     * onPatchOrderSuccess
     *
     * @param response
     */
    const onPatchOrderSuccess = function (response) {
      if (isMyPage()) {
        if (
          orderContainsConditionWithTag(
            response.data,
            'continue-past-address-page-blocker'
          )
        ) {
          // If there is an order condition that says don't continue, stay on the page and show the message
          handleMessage({
            source: 'address order condition',
            type: 'message',
            value: getConditionMessageByTagName(
              response.data,
              'continue-past-address-page-blocker'
            ),
          });
        } else {
          orderMgr.nextPage();
        }
      }
    };

    /**
     * onPatchOrderError
     *
     * @param response
     */
    const onPatchOrderError = function (response) {
      if (isMyPage()) {
        handleMessages(response.messages);
      }
    };

    /**
     * on orderMgr.orderChange
     */
    rcmEventManager.on('orderMgr.orderChange', onOrderChange, 'address');

    /**
     * on orderMgr.patchOrder.submit
     */
    rcmEventManager.on(
      'orderMgr.patchOrder.submit',
      onPatchOrderSubmit,
      'address',
      false
    );

    /**
     * on orderMgr.patchOrder.success
     */
    rcmEventManager.on(
      'orderMgr.patchOrder.success',
      onPatchOrderSuccess,
      'address',
      false
    );

    /**
     * on orderMgr.patchOrder.error
     */
    rcmEventManager.on(
      'orderMgr.patchOrder.error',
      onPatchOrderError,
      'address',
      false
    );

    $scope.$watch(
      'self.order.shipping.data.shipVia',
      renderShipMethodDescription
    );
  },
]);
